import { render, staticRenderFns } from "./SubjectMapping.vue?vue&type=template&id=1b73882c&scoped=true&"
import script from "./SubjectMapping.vue?vue&type=script&lang=js&"
export * from "./SubjectMapping.vue?vue&type=script&lang=js&"
import style0 from "./SubjectMapping.vue?vue&type=style&index=0&id=1b73882c&prod&scoped=true&lang=css&"
import style1 from "./SubjectMapping.vue?vue&type=style&index=1&id=1b73882c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73882c",
  null
  
)

export default component.exports